import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import TemplateRenderer from "../components/landing/TemplateRenderer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicLanding() {
  const { slug } = useParams();
  const [landing, setLanding] = useState(undefined);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${API}/l/${slug}`).then(({ data }) => {
      setLanding(data);
      document.title = data.content?.hero?.headline || data.title || "Landing";
      const og = document.createElement("meta");
      og.setAttribute("property", "og:image");
      og.setAttribute("content", `${API}/l/${slug}/og.png`);
      document.head.appendChild(og);
      if (data.pixel_id && !window.fbq) {
        /* eslint-disable */
        !(function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
        /* eslint-enable */
        window.fbq("init", data.pixel_id);
        window.fbq("track", "PageView");
      }
    }).catch(() => setLanding(null));
  }, [slug]);

  const submitLead = async (form) => {
    setSubmitting(true);
    setError("");
    try {
      await axios.post(`${API}/l/${slug}/lead`, form);
      setSubmitted(true);
      if (landing.pixel_id && window.fbq) window.fbq("track", "Lead");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Something went wrong — check the fields and try again.");
    } finally {
      setSubmitting(false);
    }
  };

  if (landing === undefined) {
    return <div className="min-h-screen flex items-center justify-center bg-[#FBFAF7]"><span className="font-mono text-[11px] tracking-[0.2em] text-[#A3A19B]">LOADING…</span></div>;
  }
  if (landing === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#FBFAF7]" data-testid="lp-404">
        <p className="text-4xl font-extrabold text-[#1D1E26]">404</p>
        <p className="text-[14px] text-[#6E6D68] mt-2">This page isn't live.</p>
      </div>
    );
  }

  return (
    <div data-testid="public-landing">
      {landing.engine === "v2" ? (
        <iframe title={landing.title || "Landing"} src={`${API}/l/${slug}/html`} className="fixed inset-0 w-full h-full border-0" data-testid="lp-v2-iframe" />
      ) : (
        <TemplateRenderer
          landing={landing}
          tokens={landing.tokens}
          logoUrl={landing.tokens?.has_logo ? `${API}/l/${slug}/logo.png` : null}
          onSubmitLead={submitLead}
          submitting={submitting}
          submitted={submitted}
        />
      )}
      {error && (
        <div className="fixed bottom-16 sm:bottom-5 inset-x-0 flex justify-center z-50 px-4">
          <span className="rounded-full bg-[#B4552D] text-white text-[13px] font-bold px-5 py-2.5 shadow-lg" data-testid="lp-form-error">{error}</span>
        </div>
      )}
    </div>
  );
}
